export default "__VITE_ASSET__BR1i5Vw___"